var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.06 34.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8c9fb4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.18,0H1.88C.84,0,0,.84,0,1.88v30.46c0,1.04.84,1.88,1.88,1.88h24.3c1.04,0,1.88-.84,1.88-1.88V1.88c0-1.04-.84-1.88-1.88-1.88ZM8.15,4.63h11.77c.21,0,.38-.17.38-.38v-1.46h0c1.01,0,1.84.83,1.84,1.84s-.83,1.84-1.84,1.84H7.76c-1.01,0-1.84-.83-1.84-1.84s.83-1.84,1.84-1.84h0v1.46c0,.21.17.38.38.38ZM19.54.75v3.12h-11.02V.75h11.02ZM27.31,32.34c0,.62-.51,1.13-1.13,1.13H1.88c-.62,0-1.13-.51-1.13-1.13V1.88c0-.62.51-1.13,1.13-1.13h5.89v1.29h0c-1.43,0-2.59,1.16-2.59,2.59s1.16,2.59,2.59,2.59h12.54c1.43,0,2.59-1.16,2.59-2.59s-1.16-2.59-2.59-2.59h0V.75h5.89c.62,0,1.13.51,1.13,1.13v30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.64,10.72c-.17-.12-.41-.07-.52.1l-1.6,2.36-1.6-2.36c-.12-.17-.35-.22-.52-.1-.17.12-.22.35-.1.52l1.91,2.83c.07.1.19.17.31.17s.24-.06.31-.17l1.91-2.83c.12-.17.07-.41-.1-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.45,12.07h-12.25c-.21,0-.38.17-.38.38s.17.38.38.38h12.25c.21,0,.38-.17.38-.38s-.17-.38-.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.64,17.74c-.17-.12-.41-.07-.52.1l-1.6,2.36-1.6-2.36c-.12-.17-.35-.22-.52-.1-.17.12-.22.35-.1.52l1.91,2.83c.07.1.19.17.31.17s.24-.06.31-.17l1.91-2.83c.12-.17.07-.41-.1-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.45,19.09h-12.25c-.21,0-.38.17-.38.38s.17.38.38.38h12.25c.21,0,.38-.17.38-.38s-.17-.38-.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.64,24.75c-.17-.12-.41-.07-.52.1l-1.6,2.36-1.6-2.36c-.12-.17-.35-.22-.52-.1-.17.12-.22.35-.1.52l1.91,2.83c.07.1.19.17.31.17s.24-.06.31-.17l1.91-2.83c.12-.17.07-.41-.1-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.45,26.1h-12.25c-.21,0-.38.17-.38.38s.17.38.38.38h12.25c.21,0,.38-.17.38-.38s-.17-.38-.38-.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c52693d1e4a271b5fadc4010d126f290.svg";
export { ForwardRef as ReactComponent };